import type { Props } from '@classify/react-core-components/Button';
import { SHOW_MODAL, HIDE_MODAL } from './action-types';
import { CONFIRM, ALERT } from './modal-types';

export const showConfirmModal = ({
  title,
  body,
  acceptLabel,
  cancelLabel,
  onAccept,
  onCancel,
  maxWidth,
  acceptButtonVariant,
}: {
  title: string;
  body: string;
  acceptLabel: string;
  cancelLabel: string;
  onAccept: () => void;
  onCancel?: () => void;
  maxWidth?: number | string;
  acceptButtonVariant?: Props['variant'];
}) => ({
  type: SHOW_MODAL,
  payload: {
    modalType: CONFIRM,
    modalProps: {
      title,
      body,
      acceptLabel,
      cancelLabel,
      onAccept,
      onCancel,
      maxWidth,
      acceptButtonVariant,
    },
  },
});

export const showAlertModal = ({ body, onAccept }) => ({
  type: SHOW_MODAL,
  payload: {
    modalType: ALERT,
    modalProps: { body, onAccept },
  },
});

export const hideModal = () => ({
  type: HIDE_MODAL,
});
